import { Award, Users, Globe, TrendingUp, CheckCircle, Target } from "lucide-react";

export default function AboutSection() {
  const stats = [
    { icon: Users, value: "10K+", label: "Satisfied Customers", color: "blue" },
    { icon: Globe, value: "50+", label: "Global Destinations", color: "green" },
    { icon: TrendingUp, value: "25+", label: "Currencies Supported", color: "purple" },
    { icon: Award, value: "15+", label: "Years of Excellence", color: "orange" },
  ];

  const features = [
    "RBI Approved AD II Category License for Forex Operations",
    "IATA, TAAI, and IATO certified travel services",
    "Transparent pricing with competitive exchange rates",
    "Comprehensive travel packages and visa assistance",
    "Expert guidance for international money transfers",
    "Trusted partner for corporate and individual clients"
  ];

  const getColorClasses = (color: string) => {
    switch (color) {
      case 'blue': return 'bg-blue-100 text-blue-600';
      case 'green': return 'bg-green-100 text-green-600';
      case 'purple': return 'bg-purple-100 text-purple-600';
      case 'orange': return 'bg-orange-100 text-orange-600';
      default: return 'bg-gray-100 text-gray-600';
    }
  };

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-tw-purple-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 bg-tw-orange-light text-tw-orange rounded-full text-sm font-medium mb-4">
            <Target className="w-4 h-4 mr-2" />
            About Our Company
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Transforming <span className="text-tw-orange">Financial Services</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Established in 2010, Travel Wings Forex Private Limited has been your trusted partner for comprehensive travel and forex services, combining regulatory compliance with exceptional customer service.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Our Mission & Vision</h3>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              As Travel Wings Forex Private Limited (formerly Make My Travel India Pvt. Ltd.), we operate under RBI's AD II Category license, ensuring all forex transactions meet regulatory standards. Our IATA, TAAI, and IATO memberships reflect our commitment to industry excellence.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Since 2010, we've been simplifying international travel through transparent forex services and comprehensive travel solutions, making global experiences accessible to individuals and businesses nationwide.
            </p>
            
            <div className="space-y-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center">
                  <CheckCircle className="w-5 h-5 text-green-500 mr-3 flex-shrink-0" />
                  <span className="text-gray-700">{feature}</span>
                </div>
              ))}
            </div>
          </div>
          
          <div className="relative">
            <div className="grid grid-cols-2 gap-6">
              <img
                src="https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600"
                alt="Modern office workspace"
                width={800}
                height={600}
                className="rounded-2xl shadow-lg w-full h-64 object-cover"
              />
              <img
                src="https://images.unsplash.com/photo-1559526324-4b87b5e36e44?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&h=600"
                alt="Currency exchange"
                width={800}
                height={600}
                className="rounded-2xl shadow-lg w-full h-64 object-cover mt-8"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-6 shadow-xl border border-gray-100">
              <div className="text-center">
                <div className="text-3xl font-bold text-blue-600 mb-1">99.9%</div>
                <div className="text-sm text-gray-600">Customer Satisfaction</div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Stats Section */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => {
            const IconComponent = stat.icon;
            const colorClasses = getColorClasses(stat.color);
            return (
              <div key={index} className="text-center">
                <div className={`inline-flex items-center justify-center w-16 h-16 rounded-2xl mb-4 ${colorClasses}`}>
                  <IconComponent className="w-8 h-8" />
                </div>
                <div className="text-4xl font-bold text-gray-900 mb-2">{stat.value}</div>
                <div className="text-gray-600">{stat.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
